import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import shortid from "shortid";
import { Link } from "react-router-dom";

import "../../../assets/css/utility/input-field.css";
import "../../../assets/css/utility/map.css";
import "../../../assets/css/create-load-post.css";
import "../../../assets/css/profile.page.css";
import "../../../assets/css/load-post-details-page.css";

import useHttp from "../../../hooks/useHttp";
import {
  OFFERS_GET_URL,
  OFFER_WITHDRAW_URL,
  OFFER_RE_ACTIVE_URL,
} from "../../../utils/api-ends";
import Rating from "../../../components/Rating";
import { showModal } from "../../../store/slices/modal";
import LoaderImg from "../../../assets/media/loader.gif";

const CarrierOfferList = () => {
  const [selectedOfferToWithdrawn, setSelectedOfferToWithdrawn] =
    useState(null);
  const [selectedOfferToReactivate, setSelectedOfferToReactivate] =
    useState(null);
  const [offersList, setOffersList] = useState([]);
  const [nextPageNumber, setNextPageNumber] = useState(null);

  const { isLoading: loadingFetchOfferList, sendRequests } = useHttp();
  const { isLoading, sendRequests: withdrawRequest } = useHttp();
  const { isLoading: isLoadingReactivate, sendRequests: reactivateRequests } =
    useHttp();

  const dispatch = useDispatch();
  const openLoadManageModal = (e) => {
    const description = e.currentTarget.dataset.description;
    dispatch(
      showModal({
        modalName: "OfferDescriptionModal",
        modalData: { description: description },
      })
    );
  };

  useEffect(() => {
    const response = (data) => {
      data.pagination.next_page_number > 1
        ? setNextPageNumber(data.pagination.next_page_number)
        : setNextPageNumber("");
      setOffersList(data.results);
    };
    // Send request to get carrier sended offer list
    sendRequests(
      {
        url: OFFERS_GET_URL(1),
        method: "GET",
      },
      response
    );
  }, [sendRequests]);

  //Scroll Pagination
  window.onscroll = function (ev) {
    //Check if scroll to the bottom setNextPageNumber(data.pagination.next_page_number)

    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight &&
      !["", null, undefined].includes(nextPageNumber)
    ) {
      const response = (data) => {
        setOffersList([...offersList, ...data.results]);
        setNextPageNumber(data.pagination.next_page_number);
      };

      // Send get request to get carrier sended offer list
      sendRequests(
        {
          url: OFFERS_GET_URL(nextPageNumber),
          method: "GET",
        },
        response
      );
    }
  };

  const handleWithdraw = (offerId) => {
    setSelectedOfferToWithdrawn(offerId); // For indicating to show loading

    const response = (data) => {
      setOffersList([
        ...offersList.map((offer) => {
          if (offer.id === offerId) {
            offer.status_value = "Withdrawn";
            offer.can_withdraw = false;
            offer.can_reactive = true;
          }
          return offer;
        }),
      ]);
    };
    withdrawRequest(
      {
        url: OFFER_WITHDRAW_URL(offerId),
        method: "patch",
      },
      response
    );
  };

  const handleReactivate = (offerId) => {
    setSelectedOfferToReactivate(offerId); // For indicating to show loading

    const response = (data) => {
      setOffersList([
        ...offersList.map((offer) => {
          if (offer.id === offerId) {
            offer.status_value = "Pending";
            offer.can_withdraw = true;
            offer.can_reactive = false;
          }
          return offer;
        }),
      ]);
    };
    reactivateRequests(
      {
        url: OFFER_RE_ACTIVE_URL(offerId),
        method: "patch",
      },
      response
    );
  };

  return (
    <>
      <section>
        <div className="container theme-section">
          <h1 className="large-text text-center mb-4">Submitted Offer List</h1>
          <div className="carrier-offer-table-wrapper">
            <div className="carrier-offer-table">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Shipper</th>
                    <th scope="col">Description</th>
                    <th scope="col">Load Type</th>
                    <th scope="col">Offer Amount </th>
                    <th scope="col">Counter Offer</th>
                    <th scope="col">Fixed Offer</th>
                    <th scope="col">Pickup Datetime</th>
                    <th scope="col">
                      Estimated Duration <br /> Of Delivery
                    </th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {offersList?.length > 0 ? offersList?.map((value) => (
                        <tr key={shortid.generate()}>
                          <td>
                            <div className="loader-user-info">
                              <div className="loader-user-img">
                                <img
                                  src={value.shipper_obj.profile_image}
                                  alt=""
                                />
                              </div>
                              <div>
                                <h1 className="large-text">
                                  {value.shipper_obj.name}
                                </h1>
                                <div className="user-rating">
                                  <Rating rating={value.shipper_obj.rating} />
                                  <span>({value.shipper_obj.rating})</span>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="multiple-btn description-expand">
                              <button
                                onClick={openLoadManageModal}
                                data-description={value.description}
                              >
                                Expand
                              </button>
                            </div>
                          </td>
                          <td>{value.load_post_type}</td>
                          <td>$ {value.amount}</td>
                          <td>
                            {value.counter_amount != null
                              ? "$" + value.counter_amount
                              : "- - -"}
                          </td>
                          <td>{value.can_counter === true ? "Yes" : "No"}</td>
                          <td>{value.pickup_time_formate}</td>
                          <td>{value.estimated_delivery_time}</td>
                          <td>{value.status_value}</td>
                          <td>
                            <div className="view-button-style">
                              {value?.can_view_load_post === true && (
                                <Link
                                  to={`/load-post/details/${value.load_post_obj}`}
                                  className="view-load-button"
                                >
                                  <button className="mb-2">View</button>
                                </Link>
                              )}

                              {value?.can_withdraw === true && (
                                <button
                                  onClick={() => handleWithdraw(value.id)}
                                >
                                  Withdraw
                                  {isLoading &&
                                    selectedOfferToWithdrawn === value.id && (
                                      <img
                                        style={{
                                          width: "22px",
                                          marginLeft: "8px",
                                        }}
                                        src={LoaderImg}
                                        alt="Loader"
                                      />
                                    )}
                                </button>
                              )}

                              {value?.can_reactive === true && (
                                <button
                                  onClick={() => handleReactivate(value.id)}
                                >
                                  Re-Activate
                                  {isLoadingReactivate &&
                                    selectedOfferToReactivate === value.id && (
                                      <img
                                        style={{
                                          width: "22px",
                                          marginLeft: "8px",
                                        }}
                                        src={LoaderImg}
                                        alt="Loader"
                                      />
                                    )}
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    : offersList?.length === 0
                    ? !loadingFetchOfferList && (
                        <tr className="no-offer-list-text">
                          <p>No send offer data available</p>
                        </tr>
                      )
                    : null}
                </tbody>
              </table>
              {loadingFetchOfferList && (
                <div className="justify-content-center d-flex mb-3 mt-2">
                  <img
                    style={{
                      width: "30px",
                    }}
                    src={LoaderImg}
                    alt="Loader"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default React.memo(CarrierOfferList);
